import React from "react";
import PdfBase from "./PdfBase";
import { generateMedicalExpensePdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  employeeRemunerationRows,
  medicalExpenseRows,
  totalEmployeeRemuneration,
  totalMedicalExpense,
  disallowableExpenses,
  expenseCappedAt,
  expenseCappedAmount,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    employeeRemunerationRows,
    medicalExpenseRows,
    totalEmployeeRemuneration,
    totalMedicalExpense,
    disallowableExpenses,
    expenseCappedAt,
    expenseCappedAmount,
    notes,
    reviewNotes,
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateMedicalExpensePdf(forView, ...sharedArgs)
        }
        downloadName='Medical Expense Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateMedicalExpensePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
